import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
// const cors=require('cors');
// app.use(cors())

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
